module.exports = __webpack_public_path__ + "static/media/bandcamp-logo.1d30dc3e.png";